import React, { useState } from "react";
import { DownloadButton, ResetButton } from "./_shared";
import { toast } from "sonner";

export default function Base64Decoder() {
  const [input, setInput] = useState("");
  const [outUrl, setOutUrl] = useState(null);

  const decode = () => {
    try {
      const url = input.trim().startsWith("data:") ? input.trim() : `data:image/png;base64,${input.trim()}`;
      setOutUrl(url);
      toast.success("Decoded successfully");
    } catch {
      toast.error("Invalid Base64");
    }
  };

  const reset = () => { setInput(""); setOutUrl(null); };

  return (
    <div className="space-y-6">
      <textarea
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Paste your Base64 string here (with or without data: prefix)"
        rows={8}
        data-testid="base64-input"
        className="w-full rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#1a1c20] p-4 font-mono text-xs text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500/40"
      />
      <div className="flex items-center gap-3">
        <button onClick={decode} data-testid="decode-btn" className="px-5 py-2.5 rounded-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium transition-colors">Decode</button>
        <ResetButton onClick={reset} />
      </div>
      {outUrl && (
        <div className="rounded-2xl border border-slate-200 dark:border-white/10 p-6 bg-slate-50 dark:bg-[#0b0c0e]">
          <img src={outUrl} alt="decoded" className="max-h-80 mx-auto" />
          <div className="mt-4 text-center">
            <DownloadButton href={outUrl} filename="decoded.png">Download Image</DownloadButton>
          </div>
        </div>
      )}
    </div>
  );
}
